/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Entity } from './Entity';
import {
    EntityFromJSON,
    EntityFromJSONTyped,
    EntityToJSON,
} from './Entity';

/**
 * 
 * @export
 * @interface DescribeObjectResponse
 */
export interface DescribeObjectResponse {
    /**
     * 
     * @type {string}
     * @memberof DescribeObjectResponse
     */
    companyId: string;
    /**
     * 
     * @type {Entity}
     * @memberof DescribeObjectResponse
     */
    entity: Entity;
}

/**
 * Check if a given object implements the DescribeObjectResponse interface.
 */
export function instanceOfDescribeObjectResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "companyId" in value;
    isInstance = isInstance && "entity" in value;

    return isInstance;
}

export function DescribeObjectResponseFromJSON(json: any): DescribeObjectResponse {
    return DescribeObjectResponseFromJSONTyped(json, false);
}

export function DescribeObjectResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DescribeObjectResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'entity': EntityFromJSON(json['entity']),
    };
}

export function DescribeObjectResponseToJSON(value?: DescribeObjectResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyId': value.companyId,
        'entity': EntityToJSON(value.entity),
    };
}

